<template>
  <img src="/img/payments/swish.png" width="60" height="18" alt="Swish">
</template>
